import { render, staticRenderFns } from "./resume-office-skills.vue?vue&type=template&id=50a28647&scoped=true"
import script from "./resume-office-skills.vue?vue&type=script&lang=js"
export * from "./resume-office-skills.vue?vue&type=script&lang=js"
import style0 from "./resume-office-skills.vue?vue&type=style&index=0&id=50a28647&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a28647",
  null
  
)

export default component.exports